import React from "react";
import { useLocation } from "react-router-dom";
import PageMeta from "./PageMeta";
import { PUBLIC_PAGE_SEO } from "../constants/publicPageSeo";

/** Sets document title/meta for the current public marketing route. */
export default function PublicPageSeo() {
  const { pathname } = useLocation();
  const meta = PUBLIC_PAGE_SEO[pathname];
  if (!meta) return null;
  return (
    <PageMeta
      title={meta.title}
      description={meta.description}
      path={pathname}
      noindex={meta.noindex}
    />
  );
}
